import api from "./api";
import log from "loglevel";

const state = {
  displayCommentList: [],
  originalCommentList: [],
  moreCommentsFlag: false,
  displayingTranslationText: true
};

// actions
const actions = {
  async getCommentList(context, params) {
    try {
      const res = await api.getCommentList({ code: params });
      context.commit("updateCommentList", res.data);
    } catch (error) {
      log.error("getCommentList error:", error);
      context.commit("common/setError", error, { root: true });
    }
  },
  async postComment(context, params) {
    try {
      const requestData = {
        contentIdentificationCode: params.contentIdentificationCode,
        selectedAccountProvider: params.accountProvider,
        comment: params.comment
      };
      const res = await api.postComment(requestData);
      delete params.contentIdentificationCode;
      params.commentId = res.data.commentId;
      params.twitterText = res.data.twitterText;
      params.twitterHashTags = res.data.twitterHashTags;
      params.lineText = res.data.lineText;
      params.commentUrl = res.data.commentUrl;
      context.commit("addComment", params);
      return res.status;
    } catch (error) {
      log.error("postComment error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async deleteComment(context, params) {
    try {
      const res = await api.deleteComment(params);
      context.commit("deleteComment", params);
      return res.status;
    } catch (error) {
      log.error("deleteComment error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async reportContents(context, params) {
    try {
      const res = await api.postReportContents(params);
      return res.status;
    } catch (error) {
      log.error("reportComment error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async reportComment(context, params) {
    try {
      const res = await api.postReportComment(params);
      return res.status;
    } catch (error) {
      log.error("reportComment error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async getCommentOriginalText(context, params) {
    try {
      const res = await api.getCommentOriginalText({ comment_id: params });
      context.commit("updateCommentText", {
        commentId: params,
        commentText: res.data.comment
      });
      return res.status;
    } catch (error) {
      log.error("getCommentOriginalText error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async getCommentTranslatedText(context, params) {
    try {
      const res = await api.getCommentTranslatedText({ comment_id: params });
      context.commit("updateCommentText", {
        commentId: params,
        commentText: res.data.comment
      });
      return res.status;
    } catch (error) {
      log.error("getCommentTranslatedText error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async addGood(context, params) {
    try {
      const res = await api.postAddGood(params);
      return res.status;
    } catch (error) {
      log.error("addGood error:", error);
      return error;
    }
  },
  async getContentsOriginalText(context, params) {
    try {
      return await api.getContentsOriginalText({ code: params });
    } catch (error) {
      log.error("getContentsOriginalText error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async getContentsTranslatedText(context, params) {
    try {
      return await api.getContentsTranslatedText({ code: params });
    } catch (error) {
      log.error("getContentsTranslatedText error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async postContentsSecretWord(context, params) {
    try {
      const res = await api.postContentsSecretWord(params);
      return res.status;
    } catch (error) {
      log.error("postContentsSecretWord error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async postRatingAgreements(context, params) {
    try {
      const res = await api.postRatingAgreements(params);
      return res.status;
    } catch (error) {
      log.error("postRatingAgreements error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async getContentsDetailInfo(context, params) {
    try {
      const res = await api.getContentsDetailInfo({
        contentsIdentificationCode: params
      });
      return {
        status: res.status,
        contentsDetailInfo: res.data.contentsDetailInfo
      };
    } catch (error) {
      log.error("getContentsDetailData error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async postStar(context, params) {
    try {
      const res = await api.postStar(params);
      return res.status;
    } catch (error) {
      return error;
    }
  }
};

// mutations
const mutations = {
  updateCommentList(state, payload) {
    state.originalCommentList = [...payload];
    state.displayCommentList = [...state.originalCommentList.slice(0, 3)];
  },
  addComment(state, payload) {
    state.originalCommentList = [payload, ...state.originalCommentList];
    state.displayCommentList = [payload, ...state.displayCommentList];
    if (!state.moreCommentsFlag) {
      state.displayCommentList = [...state.displayCommentList.slice(0, 3)];
    }
  },
  deleteComment(state, commentId) {
    state.originalCommentList = [
      ...state.originalCommentList.filter(
        comment => comment.commentId !== commentId
      )
    ];
    state.displayCommentList = [...state.originalCommentList];
    if (!state.moreCommentsFlag) {
      state.displayCommentList = [...state.displayCommentList.slice(0, 3)];
    }
  },
  updateCommentText(state, { commentId, commentText }) {
    state.displayCommentList = [
      ...state.displayCommentList.map(comment => {
        return comment.commentId === commentId
          ? { ...comment, comment: commentText }
          : comment;
      })
    ];
  },
  moreComments(state) {
    state.moreCommentsFlag = true;
    state.displayCommentList = [
      ...state.displayCommentList,
      ...state.originalCommentList.slice(3)
    ];
  },
  updateDisplayingTranslationText(state, payload) {
    state.displayingTranslationText = payload;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
